import type { ProductPickerItemDTO } from "@/modules/products/domain/types";

export function filterPickerProducts(
  products: ProductPickerItemDTO[],
  options: { excludeBundles?: boolean },
): ProductPickerItemDTO[] {
  if (!options.excludeBundles) return products;
  return products
    .map((product) => ({
      ...product,
      variants: product.variants.filter((v) => v.variantType !== "bundle"),
    }))
    .filter((product) => product.variants.length > 0);
}
